var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcBackwardN5028Px = function SvgIcBackwardN5028Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.172c0 .293.105.55.328.773l9.293 9.082c.2.211.457.317.762.317.61 0 1.078-.457 1.078-1.067 0-.304-.129-.562-.316-.761l-8.532-8.344 8.532-8.344c.187-.2.316-.469.316-.762 0-.609-.469-1.066-1.078-1.066-.305 0-.563.105-.762.305l-9.293 9.093c-.223.211-.328.48-.328.774Z",
    fill: "#828C97"
  })));
};
export default SvgIcBackwardN5028Px;